import { useEffect } from 'react'
import { useDispatch } from 'react-redux';
import ProviderServiceList from './ProviderServiceList';


const MaterializedView = () => {
    const menuDispatch = useDispatch();
    useEffect(() => {
        menuDispatch({
            type: 'menuSelect',
            payload: 'materialize-view'
        });
    }, []);
    
    return (
        <ProviderServiceList/>
    )
}

export default MaterializedView
